import anime from 'animejs';
import Cookie from 'js-cookie';

export default class ModalNotification {
  constructor() {
    this.selector = '.c-modal-notification';

    this.selectors = {
      inner: '.c-modal-notification__inner',
      close: '.js-notification-close',
    };

    this.classNames = {
      visible: 'is-visible',

    };

    this.cookieName = 'hailo-modal-notice-closed';
  }

  bootstrap() {
    this.load();
  }

  load() {
    const hasCookie = Cookie.get(this.cookieName);
    const modalNotification = document.querySelector(this.selector);

    if (hasCookie || !modalNotification) {
      if (modalNotification) {
        modalNotification.remove();
      }

      return;
    }

    window.addEventListener('load', () => {
      setTimeout(() => {
        modalNotification.classList.add(this.classNames.visible);

        anime({
          targets: modalNotification.querySelector(this.selectors.inner),
          opacity: [ 0, 1 ],
          delay: 500,
          duration: 1000,
          translateY: [ 100, 0 ],
          easing: 'easeOutExpo',
        });
      }, 2000);
    });

    this.handleClose(modalNotification);
  }

  handleClose(modalNotification) {
    const modalNotificationClose = [ ...modalNotification.querySelectorAll(this.selectors.close) ];
    const cookieDuration = modalNotification.dataset.cookieDuration || 30;

    if (modalNotificationClose.length === 0) {
      return;
    }

    modalNotificationClose.forEach(close => {
      close.addEventListener('click', () => {
        Cookie.set(this.cookieName, new Date().toISOString(), { expires: parseInt(cookieDuration, 10) });

        anime({
          targets: modalNotification.querySelector(this.selectors.inner),
          opacity: [ 1, 0 ],
          delay: 50,
          duration: 1000,
          translateY: [ 0, 100 ],
          easing: 'easeOutExpo',
          complete: () => {
            modalNotification.classList.remove(this.classNames.visible);
          },
        });
      });
    });
  }
}
